<template>
    <div class="coupon" >
<!--        <el-card >-->
<!--            <el-breadcrumb separator="/">-->
<!--                &lt;!&ndash; <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item> &ndash;&gt;-->
<!--                <el-breadcrumb-item>销售管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="用户邮箱">
                        <el-input v-model="searchForm.email" placeholder="用户邮箱" size="mini" :disabled="loading" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="用户姓名">
                        <el-input v-model="searchForm.name" placeholder="用户姓名" size="mini" :disabled="loading" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="发放日期">
                        <el-date-picker size="mini" v-model="searchForm.timeDate" type="daterange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" clearable >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="状态" size="mini" :disabled="loading">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未使用" value="0"></el-option>
                            <el-option label="已锁定" value="1"></el-option>
                            <el-option label="已核销" value="2"></el-option>
                            <el-option label="已作废" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini" :loading="loading">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    stripe
                    :data="tableData"
                    size="mini"
                    :loading="loading"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="用户姓名" width="200" fixed>
                    </el-table-column>
                    <el-table-column
                        prop="email"
                        label="用户邮箱">
                    </el-table-column>
                    <el-table-column
                        prop="value"
                        label="优惠券面额" width="200">
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="状态" width="200">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status === 0">未使用</el-tag>
                            <el-tag v-if="scope.row.status === 1" type="danger">已锁定</el-tag>
                            <el-tag v-if="scope.row.status === 2" type="info">已核销</el-tag>
                            <el-tag v-if="scope.row.status === 3" type="info">已作废</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200" align="right" fixed="right">
                            <template slot="header">
                                <el-button type="primary" size="mini" @click="handleAdd()">发放</el-button>
                            </template>
                            <template slot-scope="scope">
                                <!-- <el-button
                                    size="mini" type="text"
                                    :disabled="scope.row.status !== 0"
                                    @click="handleCancel(scope.row)">取消</el-button> -->
                            </template>
                        </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                            background
                            layout="sizes,prev, pager, next"
                            :total="total"
                            :page-sizes="[10, 20, 50, 100]"
                            v-if="total>0"
                            :page-size="pageSize"
                            @size-change="handleSizeChange"
                            @current-change="onPageChange"
                            :current-page="currentPage"
                            @prev-click="onPageChange"
                            @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="发放优惠券" :visible.sync="visibleSendCouponDialog" :close-on-click-modal="false" width="500px">
            <el-form ref="sendCouponForm" :model="sendCouponForm" :rules="rules" label-width="60px" size="mini">
                <el-form-item label="面额" prop="value">
                    <el-input v-model="sendCouponForm.value" placeholder="请输入优惠券面额" size="mini" clearable>
                        <template slot="prepend">￥</template>
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="客户" prop="users">
                    <el-select
                        v-model="sendCouponForm.users"
                        multiple
                        filterable
                        remote
                        reserve-keyword
                        style="width: 100%;"
                        placeholder="请输入"
                        :remote-method="handleSearchUser"
                        :loading="loading">
                        <el-option
                            v-for="item in optionUsers"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visibleSendCouponDialog = false" size="mini">取 消</el-button>
                <el-button @click="handleSend" size="mini" type="primary">发 放</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {
    data() {
        return {
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            searchForm: {},
            sendCouponForm: {},
            loading: false,
            visibleSendCouponDialog: false,
            optionUsers: [],
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
        }
    },
    methods: {
        onSearch() {
            const that = this;
            this.loading = true;
            this.$axios.post("/admin/coupon/search",{
                cond: this.searchForm, page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                const { data: resp } = response;
                if( resp.header.status == 0) {
                    that.tableData = resp.data.elements;
                    that.total = resp.data.total;
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            }).catch(function() {
                // that.optionUsers = [];
            }).finally(() => {
                that.loading=false;
            });

        },
        handleAdd() {
            this.visibleSendCouponDialog = true;

        },
        handleSend() {
            const that = this;
            this.$axios.post("/admin/coupon/send", this.sendCouponForm)
            .then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    that.$notify({
                        title: '成功',
                        message: '优惠券发放成功',
                        type: 'success'
                    });
                    that.visibleSendCouponDialog = false;
                    that.onSearch();
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            }).catch(function() {
                that.$notify.error({
                    title: '错误',
                    message: '系统错误，请稍后再试',
                });
            });
        },
        handleCancel(row) {
        },
        handleSearchUser(key) {
            const that = this;
            this.loading = true;
            this.$axios.post("/admin/user/searchUser",{
                name: key
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    that.optionUsers = resp.data.map( it => {
                        return {
                            label: it['email'] + (it['name'] ? ` (${it['name']})` : ''),
                            value: it['id'],
                        };
                    });
                }
            }).catch(function() {
                that.optionUsers = [];
            }).finally(() => {
                that.loading=false;
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        this.onSearch();
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
